import { render, staticRenderFns } from "./productIntroduction.vue?vue&type=template&id=1712d730&scoped=true&"
import script from "./productIntroduction.vue?vue&type=script&lang=js&"
export * from "./productIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./productIntroduction.vue?vue&type=style&index=0&id=1712d730&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1712d730",
  null
  
)

export default component.exports